export default __webpack_public_path__ + "static/media/abbeville4.7cb4f90d.jpg";